import { render, staticRenderFns } from "./RiskBanner.vue?vue&type=template&id=0fe2bb43&scoped=true"
import script from "./RiskBanner.vue?vue&type=script&lang=js"
export * from "./RiskBanner.vue?vue&type=script&lang=js"
import style0 from "./RiskBanner.vue?vue&type=style&index=0&id=0fe2bb43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe2bb43",
  null
  
)

export default component.exports